import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {ff, form} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
const {Form, FormActions, FormBody} = form;
import PolozkaApi from "../api/gen/cgo/PolozkaApi";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Formulář pro tvorbu/úpravu položky ceníku.
 */
class CenikPolozkaForm extends Component<WithTranslation> {

    static formName = 'CenikPolozkaForm';

    filterSuggestions = (value) => {
        return PolozkaApi.getPolozky(value, false);
    };

    render() {
        const {onClose, submitting, handleSubmit, t} = this.props;
        return <Form onSubmit={handleSubmit} horizontal>
            <FormBody>
                <ff.ApiObjectSuggest
                    label={t('order.item')}
                    name="polozka"
                    dropdown={false}
                    removable={false}
                    renderSuggestion={(item) => item ? item.nazev : ""}
                    getItemValue={(item) => item ? item.nazev : ""}
                    filterSuggestions={this.filterSuggestions}
                    placeholder={t('search_hint')}
                />
                <ff.Number double label={t('price')} name="cena" disabled={submitting}/>
                <ff.Number double label={t('discount')} name="sleva" disabled={submitting}/>
            </FormBody>
            <FormActions onClose={onClose} storeButton={t('save')} cancelButton={t('buttons.cancel')} disabled={submitting}/>
        </Form>
    }
}

export default withTranslation()(connect()(reduxForm({
    form: CenikPolozkaForm.formName,
})(CenikPolozkaForm)));
